import { getErrorMessage } from 'shared/api/errorMessage.js';
import type { ErrorActorEvent } from 'xstate';
import { assign } from 'xstate';

export const setErrorMessage = () => ({
  target: 'Error',
  actions: assign({
    errorMessage: ({ event }: { event: ErrorActorEvent<any> }) =>
      getErrorMessage(event.error).message,
  }) as any,
});
